import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import Sidebar from './components/Sidebar';
import i18next from 'i18next';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupsIcon from '@mui/icons-material/Groups';
import BarChartIcon from '@mui/icons-material/BarChart';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArticleIcon from '@mui/icons-material/Article';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import MainLoader from './components/MainLoader';
import { postApi } from './api/services';
import { serviceDown } from './utils/UtilityFunctions';


const DoctorHomepage = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [orderStats, setOrderStats] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getOrders()
  }, [])

  const goTo = (to) => {
    if(to != '') {
      navigate(`/${to}`)
    }
  }

  const getOrders = async () => {
    setIsLoading(true)
    let params = {
      email: "swapnil.sable@duretechnologies.com"
    }
    console.log("get_customer_orders params", params); 
    try{
      let res = await postApi('get_customer_orders', params)
      if(res) {
        console.log("get_customer_orders res", res); 
        setIsLoading(false)  
        setOrderStats(res)   
      }
    } catch (err) {
      setIsLoading(false)
      console.log("err", err);
      serviceDown()
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='doctorhomepage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            {/* <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate(-1, { state: { goTo: location?.state?.from }})}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div> */}
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
            <Typography variant="h6" className="title">{localStorage.getItem('doctorobj') ? JSON.parse(localStorage.getItem('doctorobj')).clinic_name : i18next.t('Clinic')}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid>
        </Grid>
        <div className='homepageimgdiv'>
          <div className='homepagegridmain'>
            <div className='gridcardmain'>
              <Grid container spacing={0} className='d-flex justify-content-center align-items-center mb-20px'>
                <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                  <h2 className='gridcardhead'>{i18next.t("Patients")}</h2>
                </Grid>
              </Grid>
              <Grid container spacing={2} className='d-flex justify-content-space-between align-items-center mb-20px mt-20px'>
                <Grid item xs={6} onClick={() => goTo('clientregistration')} className='d-flex justify-content-space-between flex-direction-column align-items-center gridcard small cursor-pointer'>
                  <PersonAddIcon className='gridcardicon'/>
                  <p className='gridcardhead'>{i18next.t("Add Patient")}</p>
                </Grid>
                <Grid item xs={6} onClick={() => goTo('clients')} className='d-flex justify-content-space-between flex-direction-column align-items-center gridcard small cursor-pointer'>
                  <GroupsIcon className='gridcardicon'/>
                  <p className='gridcardhead'>{i18next.t("All Patients")}</p>
                </Grid>
              </Grid>
            </div>
            {/* <div className='gridcardmain second'>
              <Grid container spacing={0} className='d-flex justify-content-center align-items-center mb-20px'>
                <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                  <h2 className='gridcardhead'>{i18next.t("Orders")}</h2>
                </Grid>
                <p className='mb-0 viewalltxt cursor-pointer' onClick={() => navigate('/orders')}>{i18next.t('View All')}</p>
              </Grid>
              <>
                <Grid container spacing={0} className='d-flex justify-content-center align-items-center mt-20px mb-20px ordercard'>
                  <Grid item xs={2} className='d-flex justify-content-center align-items-center p-0px pl-0px pt-0px'>
                    <BarChartIcon className='gridcardicon'/>
                  </Grid>
                  <Grid item xs={8} className='d-flex justify-content-start align-items-center p-0px pl-0px pt-0px'>
                    <p className='gridcardhead ml-10px'>{i18next.t("Total Orders")}</p>
                  </Grid>
                  <Grid item xs={2} className='d-flex justify-content-center align-items-center p-0px pl-0px pt-0px'>
                    <p className='gridcardhead count'>{orderStats?.total_orders}</p>
                  </Grid>
                </Grid>
                <Grid container spacing={0} className='d-flex justify-content-center align-items-center mt-20px mb-20px ordercard'>
                  <Grid item xs={2} className='d-flex justify-content-center align-items-center p-0px pl-0px pt-0px'>
                    <PendingIcon className='gridcardicon'/>
                  </Grid>
                  <Grid item xs={8} className='d-flex justify-content-start align-items-center p-0px pl-0px pt-0px'>
                    <p className='gridcardhead ml-10px'>{i18next.t("Pending Orders")}</p>
                  </Grid>
                  <Grid item xs={2} className='d-flex justify-content-center align-items-center p-0px pl-0px pt-0px'>
                    <p className='gridcardhead count'>{orderStats?.unfulfilled_orders}</p>
                  </Grid>
                </Grid>
                <Grid container spacing={0} className='d-flex justify-content-center align-items-center mt-20px mb-20px ordercard'>
                  <Grid item xs={2} className='d-flex justify-content-center align-items-center p-0px pl-0px pt-0px'>
                    <CheckCircleIcon className='gridcardicon'/>
                  </Grid>
                  <Grid item xs={8} className='d-flex justify-content-start align-items-center p-0px pl-0px pt-0px'>
                    <p className='gridcardhead ml-10px'>{i18next.t("Fulfilled Orders")}</p>
                  </Grid>
                  <Grid item xs={2} className='d-flex justify-content-center align-items-center p-0px pl-0px pt-0px'>
                    <p className='gridcardhead count'>{orderStats?.fulfilled_orders}</p>
                  </Grid>
                </Grid>
              </>
            </div> */}
            <div className='gridcardmain second'>
              <Grid container spacing={0} className='d-flex justify-content-center align-items-center mb-20px'>
                <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                  <h2 className='gridcardhead'>{i18next.t("Help")}</h2>
                </Grid>
              </Grid>
              <Grid container spacing={2} className='d-flex justify-content-space-between align-items-center mb-20px mt-20px'>
                <Grid item xs={6} onClick={() => goTo('')} className='d-flex justify-content-space-between flex-direction-column align-items-center gridcard small cursor-pointer'>
                  <ArticleIcon className='gridcardicon'/>
                  <p className='gridcardhead'>{i18next.t("Manuals")}</p>
                </Grid>
                <Grid item xs={6} onClick={() => goTo('')} className='d-flex justify-content-space-between flex-direction-column align-items-center gridcard small cursor-pointer'>
                  <OndemandVideoIcon className='gridcardicon'/>
                  <p className='gridcardhead'>{i18next.t("Videos")}</p>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DoctorHomepage